import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "item", "nameBtn", "expiryBtn", "ascBtn", "descBtn"]

  connect() {
    this.currentSort = "name"
    this.ascending = true
    this.updateSortUI()
  }

  sortByName() {
    if (this.currentSort === "name") return
    this.currentSort = "name"
    this.performSort()
    this.updateSortUI()
  }

  sortByExpiry() {
    if (this.currentSort === "expiry") return
    this.currentSort = "expiry"
    this.performSort()
    this.updateSortUI()
  }

  setAscending() {
    this.ascending = true
    this.performSort()
    this.updateSortUI()
  }

  setDescending() {
    this.ascending = false
    this.performSort()
    this.updateSortUI()
  }

  performSort() {
    if (!this.hasListTarget) return

    const items = Array.from(this.itemTargets)
    const sortField = this.currentSort
    const asc = this.ascending

    items.sort((a, b) => {
      const aVal = a.dataset[sortField] || ""
      const bVal = b.dataset[sortField] || ""
      const result = aVal.localeCompare(bVal)
      return asc ? result : -result
    })

    items.forEach(item => this.listTarget.appendChild(item))
  }

  updateSortUI() {
    if (this.hasNameBtnTarget) {
      this.nameBtnTarget.classList.toggle("active", this.currentSort === "name")
    }
    if (this.hasExpiryBtnTarget) {
      this.expiryBtnTarget.classList.toggle("active", this.currentSort === "expiry")
    }
    if (this.hasAscBtnTarget) {
      this.ascBtnTarget.classList.toggle("active", this.ascending)
    }
    if (this.hasDescBtnTarget) {
      this.descBtnTarget.classList.toggle("active", !this.ascending)
    }
  }
}
